import { render, staticRenderFns } from "./UserInstall.html?vue&type=template&id=90396f74&scoped=true&"
import script from "./UserInstall.js?vue&type=script&lang=js&"
export * from "./UserInstall.js?vue&type=script&lang=js&"
import style0 from "./UserInstall.scss?vue&type=style&index=0&id=90396f74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90396f74",
  null
  
)

export default component.exports